let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("foT6i"), load("bXcCM"), load("8yLIX"), load("6wr18"), load("ffEVr"), load("aFS1j"), load("2jEbr")]).then(() => parcelRequire('gaL8X'));